import { BaseApiClient } from '../base-api-client';
export class TriggerClient extends BaseApiClient {
    constructor(config) {
        super({ ...config, baseURL: `${config.baseURL}/triggers` }, 'TriggerClient');
    }
    async listTriggers(userId) {
        try {
            const response = await this.get(`/user/${userId}`);
            if (!response.success) {
                throw new Error(response.error || 'Failed to list triggers');
            }
            return response.data ?? [];
        }
        catch (error) {
            console.error(`[TriggerClient] Error listing triggers for user ${userId}:`, this.truncateError(error));
            throw error;
        }
    }
    async createTrigger(userId, payload) {
        try {
            const response = await this.post(`/user/${userId}`, payload);
            if (!response.success || !response.data) {
                throw new Error(response.error || 'Failed to create trigger');
            }
            return response.data;
        }
        catch (error) {
            console.error(`[TriggerClient] Error creating trigger for user ${userId}:`, this.truncateError(error));
            throw error;
        }
    }
    async updateTrigger(triggerId, userId, payload) {
        try {
            const response = await this.put(`/${triggerId}/user/${userId}`, payload);
            if (!response.success || !response.data) {
                throw new Error(response.error || 'Failed to update trigger');
            }
            return response.data;
        }
        catch (error) {
            console.error(`[TriggerClient] Error updating trigger ${triggerId}:`, this.truncateError(error));
            throw error;
        }
    }
    async deleteTrigger(triggerId, userId) {
        try {
            await this.delete(`/${triggerId}/user/${userId}`);
        }
        catch (error) {
            console.error(`[TriggerClient] Error deleting trigger ${triggerId}:`, this.truncateError(error));
            throw error;
        }
    }
}
//# sourceMappingURL=trigger-client.js.map